<template>
  <div>
    <div v-if="screenWidth > 1024">
      <div class="top">
        <img src="@/images/logo.png" alt />
        <p>
          <span :class="lang == 'ch' ? 'action' : ''" @click="change('ch')"
            >简</span
          >
          <i>|</i>
          <span :class="lang == 'fan' ? 'action' : ''" @click="change('fan')"
            >繁</span
          >
          <i>|</i>
          <span :class="lang == 'en' ? 'action' : ''" @click="change('en')"
            >EN</span
          >
        </p>
      </div>
      <img src="@/images/banerIndex.png" alt class="indexImg" />
      <div class="bottom">
        <div class="left">
          <div class="lefiList">
            <h1>{{ $t("bottomList[0].title") }}</h1>
            <p @click="showModel = 0">
              <img src="@/images/wechat.png" alt />
              {{ $t("bottomList[0].two") }}
            </p>
            <a href="https://weibo.com/u/7031712928?is_hot=1" target="_blank">
              <img src="@/images/sina.png" alt />
              {{ $t("bottomList[0].thre") }}
            </a>
          </div>
          <div class="lefiList">
            <h1>{{ $t("bottomList[1].title") }}</h1>
            <a
              href="https://www.lagou.com/gongsi/471310.html"
              target="_blank"
              >{{ $t("bottomList[1].two") }}</a
            >
            <a
              href="https://www.lagou.com/gongsi/471310.html"
              target="_blank"
              >{{ $t("bottomList[1].thre") }}</a
            >
            <a
              href="https://www.lagou.com/gongsi/471310.html"
              target="_blank"
              >{{ $t("bottomList[1].for") }}</a
            >
          </div>
          <div class="lefiList">
            <h1>{{ $t("bottomList[2].title") }}</h1>
            <p @click="showModel = 1">{{ $t("bottomList[2].two") }}</p>
            <p @click="showModel = 2">{{ $t("bottomList[2].thre") }}</p>
          </div>
        </div>
        <div class="right">
          <p>{{ $t("bottomTxt[0]") }}</p>
          <p>
            {{ $t("bottomTxt[1][0]") }}
            <a href="https://www.jinlingkeji.cn/index.html" target="_blank">
              {{ $t("bottomTxt[1][1]") }} </a
            >/
            <a href="https://www.caua1988.com/" target="_blank">
              {{ $t("bottomTxt[1][2]") }} </a
            >/
            <a href="http://www.cagg.org.cn/" target="_blank">
              {{ $t("bottomTxt[1][3]") }} </a
            >/
            <a href="https://www.wslndx.cn/" target="_blank">
              {{ $t("bottomTxt[1][4]") }}
            </a>
          </p>
          <p>
            {{ $t("bottomTxt[2][0]") }}
            <a href="http://beian.miit.gov.cn/" target="_blank">{{
              $t("bottomTxt[2][1]")
            }}</a>
          </p>
        </div>
      </div>
      <div class="model" v-if="showModel != -1">
        <div class="Box">
          <div class="boxTop">
            <p>{{ modelList[showModel].title }}</p>
            <img src="@/images/close.png" alt @click="showModel = -1" />
          </div>
          <div class="boxBottom">
            <img :src="modelList[showModel].img" alt />
            <p>{{ modelList[showModel].number }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="mtop">
        <img src="@/images/logo.png" alt />
        <p @click="showModel = 2">联系我们</p>
      </div>
      <div class="mcontent">
        <img src="@/images/mIndex.png" alt />
        <img
          src="@/images/andrion.png"
          alt
          @click="
            iosLoade(
              'https://lndx-app.obs.cn-north-1.myhuaweicloud.com/apk/apk_1.4.0(inner_test).apk',
              true
            )
          "
        />
        <img
          src="@/images/ios.png"
          alt
          @click="iosLoade('https://apps.apple.com/cn/app/id1501666326', false)"
        />
      </div>
      <div class="model" v-if="showModel != -1">
        <div class="Box mBox">
          <div class="boxTop mboxTop">
            <p>点击号码直接拨打</p>
            <img
              src="@/images/close2.png"
              alt
              @click="showModel = -1"
              class="close2"
            />
          </div>
          <div class="boxBottom">
            <img :src="modelList[showModel].img" alt />
            <a href="tel: 0755-2692 0484" class="boxBottomP">0755-2692 0484</a>
            <!-- <p class="boxBottomP">0755-2692 0484</p> -->
          </div>
        </div>
      </div>
      <img src="@/images/toast.png" alt class="bigToast" v-if="showbigImg" />
      <!-- <a href="https://apps.apple.com/cn/app/id1501666326">sdfsdfsd</a> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      showModel: -1,
      modelList: [],
      lang: "",
      screenWidth: document.body.clientWidth,
      showbigImg: false,
    };
  },
  mounted() {
    this.modelList = this.$t("modelList");
    window.localStorage.getItem("user_lang") == null
      ? (this.lang = "ch")
      : (this.lang = window.localStorage.getItem("user_lang"));
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  watch: {
    screenWidth(val) {
      this.screenWidth = val;
    },
  },
  methods: {
    change(name) {
      window.localStorage.setItem("user_lang", name);
      location.reload();
    },
    iosLoade(str, type) {
      var ua = navigator.userAgent.toLowerCase();
      // var isWeixin = ua.indexOf("micromessenger") != -1;
      if (type) {
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          this.showbigImg = true;
        } else {
          window.location = str;
        }
      } else {
        window.location = str;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  height: 5.875rem;
  padding: 0 7.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 184px;
  }
  p {
    display: flex;
    align-items: center;
    color: rgba(126, 126, 126, 1);
    i {
      display: block;
      font-style: normal;
      font-size: 0.375rem;
      margin: 0 0.5rem;
      margin-top: 1px;
    }
    .action {
      opacity: 1 !important;
    }
    span {
      font-size: 1rem;
      cursor: pointer;
      opacity: 0.8;
    }
    span:last-child {
      margin-top: 0.1875rem;
    }
  }
}
.indexImg {
  width: 100vw;
}
.bottom {
  padding: 3.125rem 7.5rem 3.75rem 7.5rem;
  display: flex;
  justify-content: space-between;
  .left {
    display: flex;
    .lefiList {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-right: 4.375rem;
      h1 {
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(29, 29, 29, 1);
        line-height: 1.375rem;
        letter-spacing: 1px;
        margin-bottom: 1.125rem;
      }
      p {
        display: flex;
        align-items: center;
        font-size: 0.875rem;
        font-weight: 400;
        color: rgba(126, 126, 126, 1);
        margin-bottom: 0.625rem;
        img {
          width: 1.0625rem;
          height: 0.875rem;
          margin-right: 0.4375rem;
        }
      }
      a {
        display: flex;
        align-items: center;
        font-size: 0.875rem;
        font-weight: 400;
        color: rgba(126, 126, 126, 1);
        margin-bottom: 0.625rem;
        text-decoration: none;
        img {
          width: 1.0625rem;
          height: 0.875rem;
          margin-right: 0.4375rem;
        }
      }
      a:hover {
        color: #d21c1b;
        cursor: pointer;
      }
      p:hover {
        color: #d21c1b;
        cursor: pointer;
      }
    }
    .lefiList:nth-child(3) {
      margin: 0;
    }
  }
  .right {
    margin-top: 2.75rem;
    p {
      font-size: 0.75rem;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: rgba(126, 126, 126, 1);
      margin-bottom: 0.5rem;
      text-align: right;
      a {
        text-decoration: none;
        color: rgba(126, 126, 126, 1);
      }
      a:hover {
        color: #d21c1b;
        cursor: pointer;
      }
    }
  }
}
.model {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;

  .Box {
    width: 300px;
    height: 281px;
    background: #fff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    animation: show 0.5s;
    .boxTop {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 1rem;
      border-bottom: 1px solid #e9ecef;
      box-sizing: border-box;
      p {
        font-size: 1.3125rem;
        text-align: left;
        color: #242424;
      }
      img {
        width: 0.75rem;
        height: 0.75rem;
      }
    }
    .boxBottom {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      p {
        margin-top: 30px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(36, 36, 36, 1);
      }
    }
  }
}
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
<style lang="scss" scoped>
.mtop {
  height: 45px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 125px;
    height: 26px;
  }
  p {
    font-size: 20px;
    font-weight: 400;
    color: rgba(29, 29, 29, 1);
    letter-spacing: 2px;
  }
}
.mcontent {
  height: calc(100vh - 45px);
  position: relative;
  background: #d23230;
  img:nth-child(1) {
    width: 100%;
    height: 148.42vw;
    position: absolute;
    top: 0;
    z-index: 0;
  }
  img:nth-child(2) {
    width: 69.33vw;
    height: 17vw;
    position: absolute;
    z-index: 1;
    top: 102.53vw;
    left: 50%;
    margin-left: -34.65vw;
  }
  img:nth-child(3) {
    width: 69.33vw;
    height: 17vw;
    position: absolute;
    z-index: 1;
    top: 125.53vw;
    left: 50%;
    margin-left: -34.65vw;
  }
}
.mBox {
  width: 236px !important;
  height: 213px !important;
  border-radius: 10px !important;
  .mboxTop {
    justify-content: center !important;
    position: relative;
    p {
      color: #c79a3b !important ;
    }
    .close2 {
      width: 15px !important;
      height: 15px !important;
      position: absolute;
      right: -25px;
      top: -16px;
    }
  }
  .boxBottomP {
    margin-top: 17px !important;
    margin-top: 30px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(36, 36, 36, 1);
    text-decoration: none;
  }
}
.bigToast {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: 99;
}
</style>
